export const SCREEN_MOTION = {
  initial: { opacity: 0, x: 28 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 28 },
  transition: { duration: 0.2, ease: "easeInOut" },
};
